const hash = (length = 10) => [...Array(length)].map(() => (~~(Math.random() * 36)).toString(36)).join('')

const on = (event, entity, method, param) => {
	let name
	do {
		name = `${method}_${hash(10)}`
	} while(window[name] !== undefined)

	window[name] = (e,v) => {
		e.preventDefault()
		e.stopPropagation()
		entity[method].call(entity, e, v, param)
	}

	return `on${event}="window.${name}(event,this)"`
}

const bind = (entity, attribute, callbacks = []) => {
	if(typeof callbacks === 'string') callbacks = [callbacks]

	let name
	do {
		name = `bind_${hash(10)}`
	} while(window[name] !== undefined)

	window[name] = e => {
		entity[attribute] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
		callbacks.map(callback => entity[callback].call(entity))
	}

	return `onchange="window.${name}(event)" value="${entity[attribute]}"`
}

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
function eraseCookie(name) {   
	document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export {
	on,
	bind,
	hash,
	setCookie,
	getCookie,
	eraseCookie
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_googletranslate/utils.js